module.exports = __webpack_public_path__ + "img/TE-Lockup-RGB-BLUE.98845d03.svg";